import { useCallback, useState } from 'react';
import api from '../api';

interface UseCheckOwnerNameAvailabilityResult {
  isLoading: boolean;
  error: string | null;
  isAvailable: boolean | null;
  checkOwnerName: (name: string) => Promise<void>;
}

export default function useCheckOwnerNameAvailability(): UseCheckOwnerNameAvailabilityResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);

  const checkOwnerName = useCallback(async (name: string) => {
    setIsLoading(true);
    setError(null);
    setIsAvailable(null);
    try {
      const result = await api.checkOwnerNameAvailability(name);
      // Expecting API to return { available: boolean }
      setIsAvailable(Boolean(result?.available));
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to check name availability';
      setError(errorMessage);
      setIsAvailable(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, error, isAvailable, checkOwnerName };
}
